import socialLikes from 'social-likes-next'

function initSocialLikes() {
  if ($('#share_buttons').length) {
    socialLikes(document.getElementById('share_buttons'));
  }
}

export default initSocialLikes